import RootStoreAwareViewModel from '../stores/rootStore/RootStoreAwareViewModel';

const LoggerAwareViewModel = RootStoreAwareViewModel.named('LoggerAwareViewModel').volatile((self: any) => ({
    logger: self.rootStore.getLogger(self.toString()),
}));

export default LoggerAwareViewModel;
